//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext } from 'react';

export interface UnsavedChangesContextValue {
  // Records whether `owner` holds edits it has not saved.
  readonly report: (owner: string, unsaved: boolean) => void;
  // Runs `proceed` at once when nothing is unsaved, otherwise only once the
  // user agrees to drop the unsaved edits.
  readonly confirmDiscard: (proceed: () => void) => void;
}

export const UnsavedChangesContext =
  createContext<UnsavedChangesContextValue | null>(null);
